<p-dialog
    header="Historique des statuts"
    [modal]="true"
    [closable]="true"
    [(visible)]="visible"
    appendTo="body"
    [style]="{ width: '30rem', height: '30rem' }">

    @if (historiqueMail) {
        <div class="pb-3">
            <p><strong>À :</strong> {{ historiqueMail.destinataire }}</p>
            <p><strong>Objet :</strong> {{ historiqueMail.objet }}</p>
        </div>

        @for (statut of historiqueMail.statuts; track statut) {
            <div [ngClass]="'statut ' + statut.code">
                <strong>{{ statut.libelle }}</strong>
                <small>le {{ statut.date | date: 'dd/MM/yyyy' }} à {{ statut.date | date: 'HH' }}h{{ statut.date | date: 'mm' }}</small>
            </div>
        }
    }
</p-dialog>
